import ArticleStore from "shared/src/stores/ArticleStore";

export default new ArticleStore();
